import React, { useMemo } from 'react';

import { ReactFCV } from '@types';
import { getPercentage } from '@utils/math';

import { IProgressBar } from './model';
import { StyledProgressBar, Thumb } from './styled';

export const ProgressBar: ReactFCV<IProgressBar> = ({
  min,
  value,
  max,
  successColor,
  undoneColor,
  maxWidth,
  ...props
}) => {
  const percentage = useMemo(() => getPercentage(value, max, min), [value, max, min]);

  return (
    <StyledProgressBar undoneColor={undoneColor} maxWidth={maxWidth} {...props}>
      <Thumb percentage={percentage} successColor={successColor} />
    </StyledProgressBar>
  );
};
